import _Object$keys from 'babel-runtime/core-js/object/keys';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import resolve from './resolve';

/* 
    TaskPatcher is an util to chain patch requests for consistency and delaying.
    The procedure for chaining is the folllowing:
    - each parameter has its own patch queue, with 'change' overriding the queue and 'add', 'remove' appending
      to the queue
    - when running the patch chain, the queue is popped iteratively by popping the action with the earliest timestamp
    - we always wait for the previous action to be done before popping the next one
    - there is a delay before starting the chain, in order to avoid patching too soon after the first request 
      (eg. when updating the description, title etc.)
*/

var TaskPatcher = function TaskPatcher() {
  var _this = this;

  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

  _classCallCheck(this, TaskPatcher);

  Object.defineProperty(this, 'put', {
    enumerable: true,
    writable: true,
    value: function value(paramName, method, request) {
      var payload = { request: request, timestamp: new Date().getTime(), paramName: paramName, method: method };
      switch (method) {
        case 'change':
          _this.pending[paramName] = [payload];
          break;
        default:
          if (!_this.pending[paramName]) {
            _this.pending[paramName] = [];
          }
          _this.pending[paramName].push(payload);
      }
      if (!_this.running) {
        resolve.once(_this.delayKey, _this.run, _this.delay);
      }
    }
  });
  Object.defineProperty(this, 'run', {
    enumerable: true,
    writable: true,
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var next, request;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.running = true;
                next = _this.popNext();

                if (next) {
                  _context.next = 6;
                  break;
                }

                _this.running = false;
                _context.next = 10;
                break;

              case 6:
                request = next.request;
                _context.next = 9;
                return request();

              case 9:
                _this.run();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function value() {
        return _ref.apply(this, arguments);
      };
    }()
  });
  Object.defineProperty(this, 'popNext', {
    enumerable: true,
    writable: true,
    value: function value() {
      var earliestKey = void 0;
      var earliestTimestamp = Infinity;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(_Object$keys(_this.pending)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var k = _step.value;

          var events = _this.pending[k];
          if (events.length > 0) {
            var timestamp = events[0].timestamp;

            if (timestamp < earliestTimestamp) {
              earliestKey = k;
              earliestTimestamp = timestamp;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!earliestKey) {
        return null;
      }
      return _this.pending[earliestKey].shift();
    }
  });

  this.delay = delay;
  this.pending = {};
  this.running = false;
  this.delayKey = Math.random();
};

export default TaskPatcher;
//# sourceMappingURL=TaskPatcher.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/TaskPatcher.js
// module id = 778
// module chunks = 0